import React from "react";
import styled from "styled-components";
import { NavIcon, NavBarBadge } from "./components";
import { connect } from "react-redux";
import cartIcon from "../../../images/cart-icon.svg";
import closeIcon from "../../../images/close-icon-dark.svg";

import CustomLink from "./CustomLink";
import { removeFromCart } from "../../../actions";

class Cart extends React.Component {
  removeFromCart = (id, type) => {
    this.props.removeFromCart(id, type);
  };
  render() {
    const { content, type } = this.props.cart.length ? this.props.cart[0] : this.props.cart;
    return (
      <Container>
        <NavIcon icon={cartIcon} />
        Cart
        {content && content.length > 0 && <NavBarBadge>{content.length}</NavBarBadge>}
        {content && content.length > 0 ? (
          <HoverList>
            {content.map(item => (
              <Item key={item.id}>
                <ActivityImg image={item.image} />
                <CustomLink>
                  <a
                    href={item.url}
                    target="_blank"
                    className="custom-link"
                    style={{ fontWeight: "500", fontSize: "0.875rem" }}
                  >
                    {item.name}
                  </a>
                </CustomLink>
                <PriceBlock>
                  {item.currency} {item.price}
                </PriceBlock>
                <DeleteCartItem
                  title="Remove from Cart"
                  onClick={() => this.removeFromCart(item.id, type)}
                />
              </Item>
            ))}
            <CartFooterContainer>
              <FooterContentSize>Activity: {content.length}</FooterContentSize>
              <FooterReview>
                <a href="/booking/checkout" className="custom-link">
                  Review and Checkout
                </a>
              </FooterReview>
            </CartFooterContainer>
          </HoverList>
        ) : (
          <HoverList small>
            <EmptyCart>Your Cart is empty</EmptyCart>
          </HoverList>
        )}
      </Container>
    );
  }
}

const HoverList = styled.ul`
  width: ${props => (props.small ? "20rem" : "30rem")};
  position: absolute;
  top: calc(100% + 2px);
  right: 0;
  background-color: #fff;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;

  box-shadow: 5px 5px 15px 0 rgba(0, 0, 0, 0.2);

  display: none;
  padding: 0;
  margin: 0;
  list-style: none;
  z-index: 500;
`;

export const Container = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem 0 0.2rem;
  border: 2px solid transparent;
  &:hover {
    border-bottom-color: #33cc99;
  }
  &:hover ${HoverList} {
    display: block;
  }
`;
const DeleteCartItem = styled.div`
  height: 1rem;
  width: 1rem;
  margin-left: 1rem;
  visibility: hidden;
  background-image: url(${closeIcon});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;

const Item = styled.li`
  width: 100%;
  color: #484848;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem;
  &:hover {
    background-color: #f7f7f7;
  }
  &:hover ${DeleteCartItem} {
    visibility: visible;
  }
`;

const ActivityImg = styled.div`
  height: 2rem;
  width: 2rem;
  border-radius: 100%;

  background-image: url(${props => props.image});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;

const PriceBlock = styled.div`
  font-size: 0.875rem;
  color: #484848;
  font-weight: 400;
`;

const CartFooterContainer = styled.div`
  width: 100%;
  height: 2.5rem;
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 0.5rem;
  border-top: 0.0625em solid #dfdfdf;
`;

const FooterContentSize = styled.div`
  font-size: 0.875rem;
  color: #484848;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const FooterReview = styled.div`
  font-size: 1rem;
  color: #ffffff;
  background-color: #33cc99;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .custom-link {
    color: #ffffff;
    text-decoration: none;
    height: 100%;
    padding: 0 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const EmptyCart = styled.div`
  height: 5rem;
  font-size: 1rem;
  color: #33cc99;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const mapDispatchToProps = dispatch => {
  return {
    removeFromCart: (id, type) => dispatch(removeFromCart(id, type))
  };
};
export default connect(
  null,
  mapDispatchToProps
)(Cart);
